import _ from 'lodash'

function montaTexto(palavraSelecionada) {
	return "<span class='arp-highlight-busca'>" + palavraSelecionada + '</span>'
}

function sanitizarTexto(texto) {
	//Remover caracteres proibidos, que iriam atrapalhar o regex principal.
	texto = texto.replace(/[.*+\\:\-,;/[\]?$()§`]/gi, ' ')
	return texto
}

function getPatternRegex(palavraSelecionada) {
	palavraSelecionada = sanitizarTexto(palavraSelecionada)
	let termos = palavraSelecionada.trim().split(' ')
	termos = removeElementoVazio(termos)
	if (termos.length > 0) return '(' + _.uniq(termos).join('|') + ')'
	return ''
}

function removeElementoVazio(arrayTermos) {
	return arrayTermos.filter(function (item) {
		return item.length > 0
	})
}

const filtro = (value, palavraSelecionada) => {
	if (palavraSelecionada && value) {
		let pattern = getPatternRegex(palavraSelecionada)
		if (pattern) {
			let regexpression = new RegExp(getPatternRegex(palavraSelecionada), 'gi')
			value = value.replaceAll('<strong>', '§§') // remove a abertura da tag strong e troca por outros caracteres para recolocar depois
			value = value.replaceAll('</strong>', '``') // remove o fechamento da tag strong e troca por outros caracteres para recolocar depois
			value = value.replace(regexpression, montaTexto('$1')) // da replace nas palavras pesquisadas sem as tags strong.
			value = value.replaceAll('§§', '<strong>') //recoloca a abertura da tag strong
			value = value.replaceAll('``', '</strong>') //recoloca o fechamento da tag strong
		}
		return value
	}
	return value
}

export default filtro
